import { BUSCAR_PESSOA_DESTINATARIO, SELECIONAR_PESSOA_DESTINATARIO } from '../../actions/types'

const initialState = undefined

export default function reducerPessoaDestinatario (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_PESSOA_DESTINATARIO: {
      return action.payload.data;
    }

    case SELECIONAR_PESSOA_DESTINATARIO: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
